import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useParams } from "react-router";
import {
  useRltOfferShowQuery,
  useRltOfferUpdatePostalAddressMutation,
  useRltOfferUpdateRepresentativeMutation,
  useRltOfferUpdateServiceAddressMutation,
} from "@/services/backend/rlt/offers/api/offer-api";
import { Card } from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { PostalAddressCardWithMutation } from "@/services/backend/addresses/components/postal-address-card";
import { ServiceAddressCardWithMutation } from "@/services/backend/addresses/components/service-address-card";
import { RepresentativeCardWithMutation } from "@/services/backend/representatives/components/representative-card";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function AddressesAndContactsRoute() {
  const { offerId } = useParams();
  const {
    data: offer,
    isLoading,
    error,
  } = useRltOfferShowQuery({
    id: offerId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  return (
    <div className="grid gap-2 xl:grid-cols-2">
      <PostalAddressCardWithMutation
        id={offer!.id}
        address={offer!.postalAddress}
        mutation={useRltOfferUpdatePostalAddressMutation}
        disabled={isImmutable(offer!)}
      />
      <ServiceAddressCardWithMutation
        id={offer!.id}
        address={offer!.serviceAddress}
        mutation={useRltOfferUpdateServiceAddressMutation}
        disabled={isImmutable(offer!)}
      />
      <RepresentativeCardWithMutation
        id={offer!.id}
        representative={offer!.representative}
        mutation={useRltOfferUpdateRepresentativeMutation}
        disabled={isImmutable(offer!)}
      />
    </div>
  );
}
